export {
  DateInput,
  isValidYearRange as UNSAFE_isValidYearRange,
} from './DateInput'
export type { DateInputLocales, DateInputProps } from './DateInput.types'
